// extracted by mini-css-extract-plugin
module.exports = {"InfoBoxRowContainer":"DettaglioCorsoStd_InfoBoxRowContainer__8pRDC","Testo":"DettaglioCorsoStd_Testo__m1XnO","IconaMappa":"DettaglioCorsoStd_IconaMappa__N3NZK"};